<template>
  <div id="app">
    <StakeVault />
  </div>
</template>

<script>
import StakeVault from "./components/StakeVault.vue";

export default {
  name: "App",
  components: {
    StakeVault,
  },
};
</script>

<style lang="less">
html {
  background: var(--bg);
  color: var(--color);
}

body {
  margin: 0;
  border: 0;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell,
    Noto Sans, sans-serif, BlinkMacSystemFont, Helvetica, Arial;
}

a {
  text-decoration: none;
  color: var(--color);
}

p {
  margin-block-start: 0;
  margin-block-end: 0;
}

* {
  box-sizing: border-box;
  text-decoration: none;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

input {
  outline: none;
  border: none;
  background: transparent;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
}

button {
  border: none;
  outline: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: initial;
  }
}

button:focus {
  border: 0 none;
  outline: none;
}
</style>
